import { render, staticRenderFns } from "./waiting_approval.vue?vue&type=template&id=3cab8b78"
import script from "./waiting_approval.vue?vue&type=script&lang=js"
export * from "./waiting_approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports